import { UsersApi } from '@quadminds/client-apis/users';

export const usersApi = new UsersApi();
